// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Ivkrf","container--mobile":"_1J1ZpW","heading":"_2JrAH1"};